export default __webpack_public_path__ + "static/media/le_lion14.21790840.jpg";